import { useTranslation } from 'react-i18next'
import Layout from './Layout'

const PageMaintenance = () => {
  const { t } = useTranslation()

  return (
    <Layout maintenance={true}>
      <h1>{t('label.maintenance')}</h1>
    </Layout>
  )
}

export default PageMaintenance
